var map = {
	"./demo-add-form.vue": "XEdg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3Jrb";


//////////////////
// WEBPACK FOOTER
// ./src/custom/components/grid-add-forms ^\.\/.*\.vue$
// module id = 3Jrb
// module chunks = 10